import {
  VuexModule, Module, Mutation
} from 'vuex-module-decorators'
import { Player } from '@/index'

export interface GameState {
  players: Player[];
  player: Player;
  words: string[];
  playerId: string;
  ownStream: MediaStream;
  activePlayer: Player;
  activeWordIdx: number;
  loading: boolean;
}

@Module({ name: 'game' })
export class GameModuleClass extends VuexModule implements GameState {
  players: Player[] = []
  pairs: { activeIdx: string; players: string[] }[]
  words = []
  playerId = ''
  ownStream: MediaStream = null
  activePlayer: Player = null
  activeWordIdx = 0
  loading = true

  @Mutation
  setPlayers (players) {
    this.players = players
  }

  @Mutation
  setWords (words) {
    this.words = words
  }

  @Mutation
  setId (id) {
    this.playerId = id
  }

  @Mutation
  setActive (id) {
    this.activePlayer = this.players.find(player => player.id === id)
  }

  @Mutation
  setPairs (pairs) {
    this.pairs = pairs
  }

  @Mutation
  startGame () {
    this.activeWordIdx = 0
  }

  @Mutation
  nextWord () {
    if (this.activeWordIdx < this.words.length - 1) {
      this.activeWordIdx++
    }
  }

  @Mutation
  setConnection (playerId: string, connectionId: string) {
    this.players = this.players.map(player => {
      if (player.id === playerId) {
        player.conn = connectionId
      }
      return player
    })
  }

  @Mutation
  setPlayerStream ({ playerId, stream }: {playerId: string; stream: any}) {
    this.players = this.players.map(player => {
      if (player.id === playerId && !player.stream) {
        player.stream = stream
      }
      return player
    })
  }

  get player () {
    return this.players.find(player => player.id === this.playerId)
  }

  get activeWord () {
    return this.words[this.activeWordIdx]
  }
}
